import { AdFormatConfig } from '../../../apis/graphql/types';

export enum AD_FORMAT_TYPES {
  standard = 'Standard',
  gatewayGo = 'Gateway Go',
  adSelector = 'Ad Selector',
  kervEnhanced = 'KERV Enhanced',
}

export enum AD_FORMATS_BE_TYPES {
  STANDARD = 'STANDARD',
  AD_SELECTOR = 'CHOICE',
  KERV = 'KERV_ENHANCED',
  GATEWAY_GO = 'GATEWAY_GO',
}

export const AD_FORMATS = ['STANDARD', 'GATEWAY_GO', 'CHOICE', 'KERV_ENHANCED'] as const;

export type AdFormatType = (typeof AD_FORMATS)[number];

export const AD_FORMAT_LABELS: Map<AdFormatType, string> = new Map([
  ['STANDARD', AD_FORMAT_TYPES.standard],
  ['GATEWAY_GO', AD_FORMAT_TYPES.gatewayGo],
  ['CHOICE', AD_FORMAT_TYPES.adSelector],
  ['KERV_ENHANCED', AD_FORMAT_TYPES.kervEnhanced],
]);

export const getAdFormatConfigByName = (configs?: AdFormatConfig[], adFormat?: string): AdFormatConfig | undefined => {
  return configs?.find((config) => config['adFormat'] === adFormat);
};
